export const MainPageTabs = {
  WAREHOUSES_TAB: 'warehouses-tab',
  FACTORIES_TAB: 'factories-tab',
  PORTS_TAB: 'ports-tab'
};
